export const literals = {
  currenciesName: 'Currencies',
  moreCurrencies: '172 more',
}

export const utils = {
  maxCurrenciesVisible: 10,
  lastCurrencyPosition: 9,
}
